import { useMutation } from '@tanstack/react-query';
import { rdEquipamentosService } from '../../../services/quotes/rd-equipamentos';
import { downloadBlob } from '../../../shared/utils/download-blob.util';
import { toaster } from '../../../shared/ui/toaster.component';

/**
 * Download do PDF de Cotação ou de Proposta (0171) — `tipo` explícito,
 * disponível em qualquer status da proposta. Distinto de `useOwnBackendPolicyPdf`:
 * aquele alterna proposta/apólice pela situação; este nunca alterna — é o
 * corretor quem escolhe qual dos dois baixar (dois botões, Step 5).
 */
export function useRdDocumentPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({
      proposalId,
      tipo,
    }: {
      proposalId: string;
      tipo: 'cotacao' | 'proposta';
    }) => {
      const { blob, filename } = await rdEquipamentosService.documentPdf(
        proposalId,
        tipo
      );
      downloadBlob(blob, filename);
    },
    onError: (error: unknown) => {
      const motivo =
        error instanceof Error && error.message.trim()
          ? error.message.trim()
          : 'Tente novamente em instantes.';
      toaster.create({
        type: 'error',
        title: 'Não foi possível baixar o PDF',
        description: motivo,
      });
    },
  });
}
